// Pure browser CSV parser — no Node.js dependencies
export function parseCSV(text) {
  const lines = [];
  let current = "";
  let inQuotes = false;

  // Normalize line endings
  const normalized = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

  // Split into fields respecting quoted strings (including newlines inside quotes)
  const allFields = [];
  let row = [];

  for (let i = 0; i < normalized.length; i++) {
    const ch = normalized[i];
    const next = normalized[i + 1];

    if (inQuotes) {
      if (ch === '"' && next === '"') {
        current += '"';
        i++;
      } else if (ch === '"') {
        inQuotes = false;
      } else {
        current += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ",") {
        row.push(current);
        current = "";
      } else if (ch === "\n") {
        row.push(current);
        current = "";
        allFields.push(row);
        row = [];
      } else {
        current += ch;
      }
    }
  }
  // Push last field/row
  row.push(current);
  if (row.some((f) => f !== "")) {
    allFields.push(row);
  }

  if (allFields.length === 0) return { headers: [], rows: [] };

  const headers = allFields[0].map((h) => h.trim());

  const rows = allFields
    .slice(1)
    .filter((r) => r.some((f) => f.trim() !== ""))
    .map((r) => {
      const obj = {};
      headers.forEach((h, i) => {
        obj[h] = r[i] !== undefined ? r[i] : "";
      });
      return obj;
    });

  return { headers, rows };
}
